import * as React from "react";
import { ChartRefContext } from "../context/ChartRefs";
import { ChartDataContext } from "../context/Chart";
import { Spinner } from "./Spinner";

export const PdfDownloadButton = () => {

    const [data,dispatch] = React.useContext(ChartRefContext);
    const [chartdata,] = React.useContext(ChartDataContext);

    if(chartdata.fetching) {
        return <></>;
    }

    if(data.downloading) {
        return <Spinner title={'Bezig met het genereren van de pdf'} />;
    }

    const generatePdf = () => {
        dispatch(
            {
                type: 'DOWNLOADPDF',
                payload: {},
            }
        );
    }

    const downloadPdf = () => {
        window.open(data.pdfUri,'_blank');
        dispatch(
            {
                type: 'RESETPDFDOWNLOD',
                payload: {},
            }
        );
    }

    return <>
        {data.pdfUri==='' ?
            (<button className={'c-segments__download-pdf'} onClick={generatePdf}>Pdf genereren</button>) :
            (<button className={'c-segments__download-pdf'} onClick={downloadPdf}>Pdf downloaden</button>)}
        </>
}
